import { AuthContext } from '../../context/AuthContext';
import { useContext, useEffect } from 'react';

export const useMessagesFeedSocket = (conversationId, setMessages, setIsLastMessageSentByUser, setRunScrollIntoView, isLastMessageSentByUser, messages) => {
    const { socket_context } = useContext(AuthContext);

    // hook using socket to listen for new messages
    useEffect(() => {
    if (!socket_context) {
        return;
    }
    // Listen for new messages
    const handleNewMessage = (newMessage) => {
        if (newMessage.conversationId === conversationId) {
        setMessages(prevMessages => [ newMessage, ...prevMessages]);
        setIsLastMessageSentByUser(true);
        }
    };

    // socket connection for when users are online
    socket_context.on('new-message', handleNewMessage);

    return () => {
        socket_context.off('new-message', handleNewMessage);
    };
    }, [socket_context, conversationId]);

    // hook for recovering socket & messages 
    useEffect(() => {
        if (!socket_context) {
        return;
        } else if (isLastMessageSentByUser === false) {
            const onInit = () => {
                if (socket_context.recovered && messages.length > 0) {
                    // socket connection for when a socket is disconnected
                    const lastMessageId = messages[0]._id;
                    socket_context.emit('last_message_id', {lastMessageId, conversationId})
                }
            };
        
            socket_context.on('init', onInit)
        
            // check to see if the messages sent back 
            // are different than what's in the current messages array
            socket_context.on('missed-messages', (missedMessages) => {
                if(missedMessages && missedMessages.length > 0 
                && messages.length > 0 
                && missedMessages[0]._id !== messages[0]._id) {
                setMessages(prevMessages => [...missedMessages, ...prevMessages]);
                setIsLastMessageSentByUser(true);
                setRunScrollIntoView(true);
                }
            });
        
            return () => {
                socket_context.off('init');
                socket_context.off('missed-messages');
            };
        }
    
    }, [socket_context, isLastMessageSentByUser]);
};